import { CAP_TABLE_NUMBER_FORMAT } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableSettings.ts';
import { formatCapNumber } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableUtils.ts';
import { asEnumValue } from '@dealstack/frontend/shared/utils/asEnumValue.ts';

const NUMBER_FORMAT_EXAMPLE_VALUES: Record<CAP_TABLE_NUMBER_FORMAT, number[]> = {
	[CAP_TABLE_NUMBER_FORMAT.FULL]: [14_000_000],
	[CAP_TABLE_NUMBER_FORMAT.SHORTENED]: [14_000_000, 350_000, 100],
	[CAP_TABLE_NUMBER_FORMAT.THOUSANDS]: [14_000_000],
	[CAP_TABLE_NUMBER_FORMAT.MILLIONS]: [14_000_000],
	[CAP_TABLE_NUMBER_FORMAT.BILLIONS]: [14_000_000],
};

export const getNumberFormatExample = (value: string): string => {
	const numberFormat = asEnumValue(Object.values(CAP_TABLE_NUMBER_FORMAT), value);
	if (!numberFormat) {
		return '';
	}
	return NUMBER_FORMAT_EXAMPLE_VALUES[numberFormat]
		.map((example) => formatCapNumber(example, numberFormat))
		.join(', ');
};
